module.exports = __webpack_public_path__ + "images/Towards Computer-Aided Governance of Gitcoin Grants.pdf?v=006268cd7847c2f2a8e9f1148c2e6928";